import { createContext } from '@/utils';
import type { PageExperienceContextValue } from './types';

export const PageExperienceContext = createContext<
  PageExperienceContextValue | undefined
>(undefined, 'PageExperienceContext');
